
import { ADMIN_BIOGRAPHIES, BIOGRAPHY_DOWNLOAD } from "../../../helper/url_helper";
import { axiosApi } from "../../../services/api";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBiographies = createAsyncThunk(
  "biographies/fetchBiographies",
  async (params, { rejectWithValue }) => {
    try {
      const res = await axiosApi.get(ADMIN_BIOGRAPHIES, { params });

      return res.data;

    } catch (err) {
      return rejectWithValue({
        message: err?.response?.data?.message,
        statusCode: err?.response?.status,
      });

    }
  }
);
export const downloadBiography = createAsyncThunk(
  "biographies/downloadBiography",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosApi.get(BIOGRAPHY_DOWNLOAD(id));
      // console.log("Download response:", response);

      const downloadUrl = response?.data?.data?.downloadUrl;
      if (!downloadUrl) throw new Error("No download URL");

      // const a = document.createElement("a");
      // a.href = downloadUrl;
      // a.setAttribute("download", ""); // let browser decide
      // document.body.appendChild(a);
      // a.click();
      // a.remove();
      window.open(downloadUrl, "_blank");



      return true;
    } catch (error) {
      console.log("Download error:", error);
      return rejectWithValue("Download failed");
    }
  }
);

// export const downloadBiography = createAsyncThunk(
//   "biographies/downloadBiography",
//   async (id) => {
//     const url = `${import.meta.env.VITE_API_URL}${BIOGRAPHY_DOWNLOAD(id)}`;
//     console.log("Download URL:", url);
//     // window.open(url, "_blank");
//     return true;
//   }
// );
